// extracted by mini-css-extract-plugin
export default {"watchers":"AddAlerts_watchers__oQIOK","table":"AddAlerts_table__70yx6","hideScrollBar":"AddAlerts_hideScrollBar__ABgYN"};